// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceMappingTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  'use strict';

  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');

  function WorkspaceMappingTenant(data) {
    var props = {
      //State props
      workspaceMappingId: null,
      tenantId: null,
      tenantName: '',
      id: null,
      state: 0,
      inserted: true,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null
    };

    m.extendObservable(trackable(this), props);

    data && this.readMappingTenant(data);
  }

  /**
   * Read mapping tenant data
   * @param {Object} data
   */
  WorkspaceMappingTenant.prototype.readMappingTenant = m.action(function (data) {
    this.workspaceMappingId = data.workspaceMappingId || null;
    this.tenantId = data.tenantId || null;
    this.tenantName = data.tenantName || '';
    this.id = data.id || null;
    this.state = data.state || 0;
    this.inserted = data.inserted || true;
    this.version = data.version || null;
    this.created = data.created || null;
    this.createdBy = data.createdBy || null;
    this.modified = data.modified || null;
    this.modifiedBy = data.modifiedBy || null;
  });
  
  module.exports = WorkspaceMappingTenant;
}();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.WorkspaceMappingTenant.js